import { useState } from 'react';
import { Box, Flex, Loader, Modal } from '@mantine/core';
import type { Client } from 'src/admin/users/types';
import MemberSearchList from 'src/clients/CreateFamilyV2/MemberSearchList';
import { SearchPill } from 'src/UI/generate-flow/SearchPill';

type Props = {
  opened: boolean;
  onClose: () => void;
  onToggle: (client: Client) => void;
  selectedMembers?: Client[];
  size?: string | number;
  loading?: boolean;
};

export function ClientSearchModal({
  opened,
  onClose,
  onToggle,
  selectedMembers = [],
  size = 'md',
  loading = false,
}: Props) {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      size={size}
      padding="lg"
      overlayProps={{ backgroundOpacity: 0.55, blur: 8 }}
      styles={{ content: { backgroundColor: 'transparent', boxShadow: 'none' } }}
    >
      <SearchPill value={searchTerm} onChange={setSearchTerm} placeholder="Search client" />
      <Box mt="sm" bg="white" style={{ borderRadius: 24 }}>
        {loading ? (
          <Flex justify="center" align="center" p="xl">
            <Loader />
          </Flex>
        ) : (
          <MemberSearchList
            selectedMembers={selectedMembers}
            onToggle={onToggle}
            searchTerm={searchTerm}
            noScroll
            radius={24}
          />
        )}
      </Box>
    </Modal>
  );
}
